exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "scenes .main-switch{font-size:16px;width:70px;margin-top:-40px}scenes .main-switch .md-label{min-width:100px!important}scenes .main-switch i{position:relative;top:4px}scenes .scene-description{font-size:13px;display:inline-block;max-width:590px}scenes .ratio-container{font-size:12px;margin:-15px 0 -12px;min-width:590px}scenes .photos-within-layout{position:relative;z-index:10;font-size:12px}scenes .photos-within-layout md-input-container .md-input:disabled{color:rgba(0,0,0,.38)}scenes .photos-within-layout md-input-container .md-input{color:rgba(0,0,0,.87)}scenes .scenes-photo{margin:14px 0 -22px}scenes .scenes-random{display:flex;margin:0 0 5px;z-index:30;font-size:13px;width:fit-content;min-width:620px}scenes .opacity-slider-block{max-width:270px;margin:0 auto;padding-top:50px}scenes .opacity-slider-block p{margin:0;margin-bottom:5px;text-align:justify!important}scenes .opacity-slider-block p.opacity-note{font-size:10px}scenes .scene-btn-title .form-alert{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/configurations/scenes/scenes.scss
// module id = 322
// module chunks = 0